// extracted by mini-css-extract-plugin
export default {"item":"styles_item__8ISuo","itemContainer":"styles_itemContainer__vz7T2","header":"styles_header__tQrE2","footer":"styles_footer__YFowm","icon":"styles_icon__lK93q"};